import { styled } from '@mui/material/styles'
import { Stack, FormControl } from '@mui/material'

export const StyledFormContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.spacing(1),
  borderColor: theme.palette.divider,
}))

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    color: theme.palette.grey[600],
  },
  '& .MuiFormLabel-root.Mui-focused': {
    color: theme.palette.grey[600],
  },
  '& .MuiFilledInput-root': {
    backgroundColor: theme.palette.grey[50],
    color: theme.palette.grey[600],
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
    },
    '&.Mui-focused': {
      backgroundColor: theme.palette.grey[50],
    },
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.grey[600],
  },
}))
